<script setup lang="ts">
/**
 * @author Beka Chkhaidze
 */

import Button from "@/components/regularComponents/UIComponents/Button.vue";

import Phone from "@/components/regularComponents/UIComponents/SVG/Social/Phone.vue";
import Email from "@/components/regularComponents/UIComponents/SVG/Social/Email.vue";

import { useMainStore } from "@/store/main/index";

import { getWidgetSS } from "@/composables/core/func";

const Link = defineAsyncComponent(
  () => import("@/components/regularComponents/UIComponents/Link.vue")
);

const mainStore = useMainStore();

await getWidgetSS(["contact-where-we-are"]);

const data = computed(
  () =>
    mainStore.widgets?.["contact-where-we-are"]
);
</script>

<template>
  <div class="contact-us__who-we-are pos-rel">
    <h2 class="head uppercase">{{ data?.title }}</h2>

    <div class="sub" v-html="data?.address1"></div>

    <span v-if="data?.address2" class="d-flex j-center separator">{{ $t("and") }}</span>

    <div class="sub" v-if="data?.address2" v-html="data?.address2"></div>

    <div class="contact-us__who-we-are-buttons">
      <Link :label="data?.direction?.title" :link="data?.direction">
        <Button
          :noTranslate="true"
          :btnText="data?.direction?.title"
          :btnType="4"
          class="padding-lg"
        ></Button>
      </Link>

      <Link :label="data?.phone1?.title" :link="data?.phone1">
        <Button :noTranslate="true" :btnType="4" :btnText="data?.phone1?.title">
          <Phone class="icon" />
        </Button>
      </Link>

      <Link :label="data?.phone?.title" :link="data?.phone">
        <Button :noTranslate="true" :btnType="4" :btnText="data?.phone?.title">
          <Phone class="icon" />
        </Button>
      </Link>

      <Link :label="data?.mail?.title" :link="data?.mail">
        <!-- <Button :noTranslate="true" :btnType="4" :btnText="data?.mail?.title">
          <Email class="icon" />
        </Button> -->

        <button
          :aria-label="data?.mail?.title"
          class="button d-flex al-center j-center ov-hidden button--4"
        >
          <Transition name="fade" mode="out-in">
            <div class="d-flex al-center">
              <ClientOnly>
                <Email class="icon" />
              </ClientOnly>

              <span class="p-16 button__content c-black pos-rel">
                {{ data?.mail?.title }}
              </span>
            </div>
          </Transition>
        </button>
      </Link>
    </div>
  </div>
</template>
